import DragoslavPavlovic from "../src/assets/img/team/DragoslavPavlovic.jpg"
import TrungTinShinji from "../src/assets/img/team/TrungTinShinji.jpg"
import Avelsia from "../src/assets/img/team/Avelsia.png"
import Enlightened from "../src/assets/img/team/Enlightened.jpg"
import AdrianTroncoso from "../src/assets/img/team/AdrianTroncoso.png"
import PetarC from "../src/assets/img/team/PetarC.png"
import Rhythm from "../src/assets/img/team/Rhythm.png"
import BornaB from "../src/assets/img/team/BornaB.png"
import Yuma from "../src/assets/img/team/yuma.png"
import Mattastico from "../src/assets/img/team/Mattastico.jpg"
import MilanM from '../src/assets/img/team/MilanM.png'
import KevinB from '../src/assets/img/team/KevinB.png'
import EniolaO from '../src/assets/img/team/EniolaO.png'

export const TEAM = [
  {
    wizardId: 7874,
    username: "Wizzard Blizzard",
    name: "",
    title: "Founder",
    desc: "Involved in the cryptocurrency space since 2013, Wizzard Blizzard was part of the original Ethereum DAO," +
      " and went on to later become a part of Aragon, a blockchain project specializing in helping other projects" +
      " create their own DAOs. Wizzard is also part of another blockchain project that has developed its own" +
      " blockchain and is developing a decentralized internet.",
    desc2: "Apart from his experience in the cryptocurrency arena, Wizzard also has experience forming and leading" +
      " gaming communities and clans since 2003, and continues this until today with the creation of Cosmic Universe," +
      " which was founded in June of 2021. He also holds a Bachelor’s degree in Business Administration & Finance." +
      " Wizzard has also been a life coach, DJ, and music producer for the past 15 years."
  },
  {
    wizardId: 821,
    username: "Cool Vibrations",
    name: "Aaron P",
    title: "CTO",
    desc: "Since he was a young boy, Aaron has been obsessed with video games and technology. At age 12, he started" +
      " writing his first lines of code learning web development. After working several jobs in IT, he later went on" +
      " to start his own business in IT, graphic design, website design, development, and optimization. The business" +
      " has now been in successful operation for over 10 years.",
    desc2: "During this time, Aaron has gained the necessary leadership and management skills to run a strong" +
      " business and become a masterful problem solver. Aaron has also been creating music for over 8 years, dabbling" +
      " in a handful of genres. He has also worked in hobby level design for several different video game engines" +
      " over the years."
  },
  {
    wizardId: 991,
    username: "Mr. M",
    name: "",
    title: "Lead Strategist",
    desc: "Mr. M’s prior experiences include 10+ years experience as an Intelligence Analyst for the United States" +
      " Air Force and Supply Chain Management Coordinator. He is currently a FINRA licensed Financial Advisor who" +
      " holds his Series 7, Series 66, and Life Health and Annuity licensing.",
    desc2: "He is also currently leading a small Harmony project called Troll Guild, which is a gaming and completion" +
      " guild on the LootSwap decentralized exchange, and has been part of the crypto community since 2009. He looks" +
      " forward to helping Cosmic Universe expand across the stars, and brings his experience and background to add" +
      " value to the project and community."
  },

  {
    img: DragoslavPavlovic,
    username: "Drago",
    name: "Dragoslav Pavlovic",
    title: "Chief Game Developer",
    desc: "Dragoslav is an Unreal Engine and 3D graphics expert with 12 years of experience in real-time 3D graphics" +
      " applications who also specializes in enterprise projects such as metaverses and digital twins. He started" +
      " working with 3D graphics in early 2010 while still in elementary school. With the help of good mentors, he" +
      " quickly realized that it’s not enough just to make nice-looking art, but also to make it proper from" +
      " technical aspects as well. Dragoslav is constantly learning new things, researching new techniques and" +
      " technologies in order to improve the quality, speed ,and efficiency of his work. While being a very capable" +
      " individual, he’s a team player as well with proven leadership skills.",
    desc2: "Dragoslav enjoys sharing knowledge and mentoring younger colleagues. In his spare time, he develops" +
      " software tools and courses for his own academy."
  },
  // {
  //   wizardId: 1738,
  //   username: "Lore Master Riptide",
  //   name: "",
  //   title: "Project Coordinator",
  //   desc: "Inspired by the various RPGs he played over two decades, Riptide has been honing his craft writing" +
  //     " fiction over the same period of time. He has written two novels (both in a fantasy series), countless short" +
  //     " stories (of varying genres), and has done freelance writing for multiple projects. Whether it is playing" +
  //     " Dungeons and Dragons, playing video games, or writing stories, Riptide enjoys fantasy and world building. He" +
  //     " has a passion for all things magical, mystical, and supernatural. Riptide hopes to bring his enthusiasm for" +
  //     " worldbuilding and creativity to Cosmic Universe.",
  //   desc2: "“The most fantastical thing about this world, is that it doesn’t have to be the only one.”"
  // },
  {
    img: "https://media-exp1.licdn.com/dms/image/C4E03AQHbyroyU4hMnQ/profile-displayphoto-shrink_800_800/0/1603338771095?e=1666828800&v=beta&t=ZsrnNJNItZLHx9De-KWdhA-I2JKWqUYjAX58TzHQhEw",
    username: "DirtyCajunRice",
    name: "Nicholas St. Germain",
    title: "Lead Solidity Developer",
    desc: "Cajun has a rich background in the tech and game industry, with a passion for bleeding-edge technology and" +
      " and a security-first mindset. Always hungry for knowledge, he has experience in a bevvy of coding languages," +
      " cloud platforms, and their applications. He brings with him all of the knowledge he has gained from his prior" +
      " employment at Electronic Arts and various cloud providers. He has a no-nonsense attitude bootstrapped with a" +
      " seldom paralleled drive for improvement in every task no-matter the size.",
    desc2: "“I am always doing that which I cannot do, in order that I may learn how to do it.” - Pablo Picasso"
  },
  {
    img: PetarC,
    wizardId: 0,
    username: "Petar C",
    name: "",
    title: "Lead 3D Character Artist",
    desc: "Petar had discovered 3D modeling in 2013 and ever since then his passion for game art has only" +
      " continued to grow. Years of experience in various areas of 3D art gave him the generalist knowledge and" +
      " leadership skills to be able to spend the past year working as a full-time Lead, running art teams on several" +
      " game projects.",
    desc2: "His specialty for 3D character art and immense passion for fantasy worlds makes him feel right at home" +
      " while working on Cosmic Universe, bringing his and the team's imagination to life."
  },
  {
    img: BornaB,
    wizardId: 0,
    username: "Borna B",
    name: "",
    title: "Lead Technical Artist",
    desc: "Borna's infatuation with 3D modeling began 8 years ago. Spending the past several years working on both" +
      " Entertainment and Enterprise projects allowed Borna to garner a wide net of skills from the technical and" +
      " artistic side of game creation, while experience with running teams allowed them to learn about leadership" +
      " and management.",
    desc2: "The ability to perform both highly artistic and technically challenging tasks, especially around" +
      " characters, make Borna really excited to work on Cosmic Universe!"
  },
  {
    img: Avelsia,
    wizardId: 0,
    username: "Avelsia",
    name: "",
    title: "Project Manager",
    desc: "Avelsia has been an avid gamer since she was 6 years old. This has led her to playing virtually every" +
      " major game franchise over the past two decades. Turning her passion into her career, she entered the world of" +
      " esports initially as a player before transitioning to management.",
    desc2: "Coupled with her prior experience as a Software Engineer in the Fintech industry, she strives to apply" +
      " her unique skill sets and experiences to help usher in a new generation of gaming."
  },
  {
    img: Enlightened,
    wizardId: 0,
    username: "Enlightened",
    name: "",
    title: "Community Manager",
    desc: "Enlightened is a cryptocurrency enthusiast with a rich background in project relations, having over 5" +
      " years of experience in the field. Coupled with a long career history of team management and customer service," +
      " Enlightened intends to help the community by fostering peace and Harmony through guidance and support.",
    desc2: "With a deep love of the anonymity of cryptocurrency, Enlightened also appreciates the enjoyment an online" +
      " MMORPG can bring when you're building your own story for your character. Enlightened has a passion for gaming" +
      ", with over 15 years experience playing various MMORPGs and is very excited to see what the next 15 years will" +
      " bring."
  },
  {
    img: Yuma,
    wizardId: 0,
    username: "Yuma",
    name: "",
    title: "Community Manager",
    desc: "Yuma is a talented multi-linguist with a great interest in crypto-gaming technology. She has a passion" +
      " for helping others and spends much of her time chatting with the wonderful wizards in the community.",
    desc2: "Having been involved in cryptocurrency for over a year, Yuma is excited to bring her skills to the Cosmic" +
      " Universe Team as Community Manager to build a brighter future for crypto-gaming."
  },
  {
    wizardId: 8779,
    username: "Waffle",
    name: "",
    title: "Creative Coordinator",
    desc: "Waffle comes from a 15 year background in Photography & Design and was drawn in by Cosmic Universe's" +
      " stunning visuals. Being in the media industry for that long means he can bring this expertise to the" +
      " promotion of CU. Once established in the discord server it was very apparent he wanted to become part of the" +
      " team to show off the game to its full potential. ",
    desc2: "He has been gaming since the age of 5 and if he’s not creating static artwork for the project he will be" +
      " inside Unreal Engine 5 capturing stunning images and videos to promote the game up until its launch, and" +
      " beyond."
  },
  {
    wizardId: 7998,
    username: "Cheezy",
    name: "",
    title: "Community Moderator",
    desc: "Cheezy is excited to help cultivate a peaceful and harmonious environment within the Discord community as" +
      " a Community Moderator"
  },
  {
    img: Rhythm,
    wizardId: 0,
    username: "Rhythm",
    name: "",
    title: "Technical Advisor",
    desc: "Rhythm is a full-stack software developer with a passion for crypto and gaming. He is always looking for" +
      " an interesting problem to solve and enjoys focusing on optimization and security. He loves learning new" +
      " things and meeting new people. He holds a Bachelor's degree in Computer Science. Rhythm got involved with" +
      " Harmony in the Summer of 2021. He has met people from a variety of projects on the chain, which ultimately" +
      " led him to Cosmic Universe. His love for Harmony and decentralization has led him to help dozens of " +
      "validators set up nodes on the chain.",
    desc2: "His passion for video games stretches back to his childhood when he played his first game, Super Mario" +
      " Bros, on the NES. Since then he's played every genre of game and is especially drawn to RPGs and puzzle" +
      " games. He has played nearly all of the popular MMOs in the last 15 years and can't wait to add Cosmic" +
      " Universe to that list."
  },
  {
    img: Mattastico,
    wizardId: 0,
    username: "Mattastico",
    name: "",
    title: "Lore Writer",
    desc: "Mattastico has been an avid writer and creator his whole life; inspired by classic fantasy-based" +
      " novels, movies, and old-school RPG.  He believes breaking the concept of reality is the key to true" +
      " creativity.  This passion has inspired Mattastico to become involved with the Cosmic Universe in order to" +
      " help them bring that vision to life.",
    desc2: "Having been involved in the blockchain space since late 2017, Mattastico sees the potential of the Cosmic" +
      " Universe and its benefits for the world. Cosmic Universe should not simply be viewed as play-to-earn; but" +
      " a gateway to a fantastic and magical world where enchantment and community come together in a universe with" +
      " infinite possibilities. Mattastico resides in Los Angeles, California where he is currently writing and" +
      " working on projects in the industry."
  },
  {
    img: KevinB,
    wizardId: 0,
    username: "Kevin B.",
    name: "",
    title: "3D Artist/Production Assistant",
    desc: "Kevin is a 3D generalist with a few years of experience as a freelancer. He is a mostly self-taught " +
      "artist who doesn't shy away from learning new things or software to get a job done. Started out as an " +
      "archviz artist and overtime grew his skillset to be able to take on more work. In the last couple of " +
      "years, he has had the chance to work on multiple big projects for local as well as international " +
      "companies. He loves almost everything regarding 3D and is looking forward to working on converting all " +
      "the innovative concepts into 3D masterpieces."
  },
  {
    img: EniolaO,
    wizardId: 0,
    username: "Eniola O.",
    name: "",
    title: "3D Artist",
    desc: "Eniola is a self-taught 3D artist with a primary focus on characters and hard surfaces. Over the" +
      " years of his professional experience, he has had the opportunity to work with several studios " +
      "(especially VR). His passion of converting anything in the real world into virtual space has led him to" +
      " push his skills farther than he could have ever hoped for. Eniola has extensive understanding of the " +
      "latest industry tools and is still always ready to learn more every day. He doesn't shy away from taking " +
      "on and solving any challenge, no matter how long it takes."
  },
  {
    wizardId: 9515,
    username: "SJ",
    name: "",
    title: "2D Artist",
    desc: "SJ has worked as a 2D artist and animator since 2011, with her work featuring in galleries, theatre" +
      " productions and print media. Most recently, she is working as the cover artist for a book series.",
    desc2: "She's excited to bring her skills and experience to the Cosmic Universe community."
  },
  {
    wizardId: 9740,
    username: "Lionel",
    name: "",
    title: "Blockchain Web3 Developer",
    desc: "Lionel is a senior full-stack blockchain developer with a broad and versatile coding skillset. He has" +
      " worked with tech companies for over 6 years, helping to build technology-based businesses from the ground up." +
      " His strong theoretical and practical background in IT, business consulting, and project management help him" +
      " support Cosmic Universe in many of its endeavors.",
    desc2: "Lionel has been collaborating with a variety of companies, including small startups and big communities," +
      " which has made him intimately familiar with all the stages of the web lifecycle from the initial architecture" +
      " to final deployment. He enjoys learning new technologies and sharing findings with his colleagues."
  },
  {
    img: MilanM,
    wizardId: 0,
    username: "Milan M.",
    name: "",
    title: "3D Artist Intern",
    desc: "Milan is a 3D Character Artist with a couple of years of experience in the 3D world. With an IT " +
      "background and a passion for playing games, he developed an interest in 3D design which lead him into " +
      "learning how to create game characters. He is very keen on developing his skills and learning new " +
      "software to be able to improve the quality of his work."
  },
]

export const Retired = [
  {
    img: TrungTinShinji,
    wizardId: 0,
    username: "Trung Tin Shinji",
    name: "",
    title: "Concept Artist",
    desc: "Shinji is an artist with over 8 years of experience within the concept art arena of the gaming" +
      " industry. Besides being a concept artist for Cosmic Universe, he is currently working as a lead artist for" +
      " an indie game studio, and together they have worked with the industry for a considerable amount of time." +
      " Having a tremendous amount of passion for gaming and cryptocurrency, Shinji strives to do everything he can" +
      " to deliver captivating fantasy art."
  },
  {
    wizardId: 0,
    username: "Lost Indicator",
    name: "",
    title: "3D Modeler",
    desc: "Lost Indicator has 10+ years of 3D modeling experience. His passion for gaming started as a child with" +
      " Atari and continues to this day with RPG, adventure, and RTS games. Blending dreams with reality has helped" +
      " him become a master of his craft and design 3D models and entire levels with ease. Lost Indicator also has a" +
      " background in Python.",
    desc2: "His claim to fame is watching thousands of hours of anime. For him, games are a way of telling a great" +
      " story, having a fun time, and playing the role of someone magical with special powers. This is why he is" +
      " especially a fan of games that have lore and a story behind them."
  },
  {
    img: AdrianTroncoso,
    wizardId: 0,
    username: "Adrian Troncoso",
    name: "",
    title: "3D Environmental Artist",
    desc: "Adrian is a 3D Environment Artist based in Los Angeles with 4 years of experience in the animation" +
      " industry. His main software are Maya, Zbrush, and Substance Painter. He has worked in Environment art" +
      "development for television, commercials and video games. Before this, he was working as an office assistant " +
      "at Disney Television Animation, and had the opportunity to find mentors that guided him and provided the" +
      " critique needed to push himself as an artist. Inspired by these mentors, he looked back into layout and" +
      " background art from classic Disney animated films, and created several pieces that landed him his first job" +
      " in the animation industry. He is a team player and is always ready for a new challenge, even ready to lead" +
      " when necessary.",
    desc2: "He’s a geek when it comes to Disney movies and Star Wars, and is very passionate about video games as" +
      " well; he was playing Pokemon Yellow before he could read. When he’s not working, Adrian enjoys working out," +
      " sculpting in clay, and hanging out with friends and family. He’s excited to enter the crypto space and help" +
      " develop worlds in this new realm of storytelling."
  },
  {
    "title": "Darth Wizard",
    "subtitle": "Community Development Manager",
    "desc": "DarthWizard has played more games in his life than he can remember. As a passionate gamer, he knows that the community is the heart of every game. He is usually found on the Cosmic Universe Discord and social channels, listening to the needs of the community and making sure they are met.<br/><br/>With 5+ years experience working as a coach, as well as over a decade of experience in customer relationship management, DarthWizard is looking to use this experience to help foster a passionate community."
  },
  {
    "title": "Crypto Clay",
    "subtitle": "Advisor",
    "desc": "Clay has been an avid crypto enthusiast for 9 years and a gamer for 26 years. Building PCs and gaming made up a majority of his childhood. DOOM was his first gaming experience. From there, he branched out to hundreds of other games including: WoW, Starcraft, Counter Strike 1.6, CoD, Battlefield, Rust, Tarkov, and many more. <br/><br/> Founder of Cerebral Gaming DAO, Clay is currently working on community building throughout the Harmony ecosystem. One of the ways he is achieving that goal is through his YouTube channel. Family is the most important thing in Clay's life, with Crypto and Gaming coming in a close second. He and his wife Taylor currently live in Oklahoma, have two dogs, two cats, and a baby on the way."
  },
  {
    "title": "Fartein Orestad",
    "subtitle": "Music Composer",
    "desc": "Fartein is a music composer, producer, and DJ based in Norway. He has written and produced music " +
      "for commercials, film, TV, and radio shows, as well as for other artists and his own solo projects. " +
      "Fartein holds a Master's degree in music, and his varied work reflects an eclectic taste in music, " +
      "ranging from Lo-Fi and House to Orchestral music."
  },
  {
    "title": "Shantastic",
    "subtitle": "Community Manager",
    "desc": "Shantastic first discovered crypto during the 2017 bull run, but really got back into it early 2021. She did a deep dive into the P2E NFT metaverse, and found something to be truly passionate about and has never looked back since.<br/><br/>She has been a gamer since she got her first Sega at 5 years old, Obsessed with Pokemon, Shantastic spent over a decade playing World of Warcraft and also enjoys a game (or 10) of Overwatch. She has over a decade of experience in management within the retail sector of the gaming industry, and has a wide range of knowledge within both the crypto space and gaming industry.<br/><br/>Shantastic has been community building on social media for the better part of a year, and hopes to bring her knowledge, love of people, and passion for Cosmic Universe, to create a MMORPG and community that everybody can be proud to be a part of."
  },
  {
    "title": "David J.",
    "subtitle": "Blockchain Developer",
    "desc": "David has been a blockchain developer since 2017, specializing in Including, DeFi DEXs, blockchain forks, and smart contracts. He also has experience with Bitcoin, Polymesh, Chainlink, Binance Smart Chain, Harmony, Ethereum, Solana, and Hyperledger. David has extensive experience with Python, Django, AWS, R, Hadoop, SQL, Bash, PostgreSQL, MySQL, and MS SQL. He has been in the IT field since the 2012.<br/><br/>David enjoys working on blockchain projects that provide the opportunity to make the world a better place, and looks forward to helping Cosmic Universe do exactly that."
  },
  {
    "title": "Geir",
    "subtitle": "Advisor",
    "desc": "Geir is a strategist who see the bigger picture of how things fit together within the Cosmic Universe ecosystem. His ideas and inputs assist Cosmic Universe to continually improve by providing insights into general and targeted strategies that support the project's success. His background and experience are in market psychology, marketing, human psychology, and international business."
  },
  {
    "title": "Petachu",
    "subtitle": "Advisor",
    "desc": "Petachu has been involved in the cryptocurrency space since 2017, and entered into the Harmony ecosystem in 2021. He hopes to leverage his knowledge to onboard others to Harmony and expand the Cosmic Universe community by planning captivating events. Petachu also has past experience in creating events in his prior job, along with analytics-driven projects. He aspires to bring along his event planning experience to create a variety of unique and engaging events that facilitate the further growth and expansion of Cosmic Universe. He is also interested in helping out with new player onboarding as new players enter the Cosmic Universe community.<br/><br/>Petachu holds a Bachelors degree in Management Information System and a Masters degree in Business Analytics. In his free time, he enjoys watching sports, both traditional and e-sports, with his favorite game being League of Legends."
  },
  {
    "title": "Cuniplz",
    "subtitle": "Growth Lead",
    "desc": "Cuniplz is an entrepreneur with 7+ years experience ranging from founding several businesses from scratch and scaling them. His lead project has successfully grown from two to 20 employees, and Cuniplz has now successfully launched two subsidiaries. He has always been driven by the challenges of taking an idea to convert it into its best business reality. He loves strategic thinking and brainstorming, all while challenging the status quo. Throughout his career, Cuniplz has also developed strong sales and communications skills.<br/><br/>He holds a Bachelors degree in Management Science and a Masters degree in Entrepreneurship. Cuniplz started his cryptocurrency journey in 2018, and began to really become passionate about it in early 2021, especially about the blockchain gaming industry. Cuniplz is now driven to apply all of his knowledge, skills, and passion to make the Cosmic Universe grow."
  },
  {
    "title": "Fabian Grundmann",
    "subtitle": "Lead Unreal Engine Developer",
    "desc": "Fabian has been working as a game designer and developer for the past 5 years. His vision is to shine a positive light again on games since playing them is not a waste of time but can actually bring tremendous value to peoples' lives, including creating jobs, passive sources of income with blockchain games, and more. He is currently also trying to bring people back together with virtual fairs and similar events. as well as much more.&nbsp;<br/><br/>For Fabian, level design and development is so exciting because it allows him to create not only new worlds but also visualize and realize the dreams of others. Fabian is excited to help Cosmic Universe actualize its vision of a play-to-earn adventure MMORPG."
  },
]
